import { useDispatch, useSelector } from 'react-redux';
import { CSV_HEADERS } from "../common/statics";
import { updateProperty } from "../context/fileReducer";
import { INT_FIELDS } from "../common/statics";

export const useDrawRow = () => {
    const dispatch = useDispatch();
    const rowErrors = useSelector(state => state.rowErrors || {});

    const getRow = (row, index) => {
        const cellErrors = rowErrors[index]?.cellErrors || {};

        const tds = Object.entries(row).map(([columnName, columnValue]) => {
            const errors = cellErrors[columnName] || [];
            const errorsExists = errors.length > 0;
            const finalStyle = getStyle(errorsExists);
            return (
                <td style={finalStyle} key={columnName + index}>
                    <div data-toggle="tooltip"
                        title={errors}
                        style={{ display: 'flex', width: '51px' }}
                    >
                        {getInputColumn(columnValue, index, columnName, errorsExists)}
                        {errorsExists &&
                            <img src="searching.png" alt="" style={{ width: '30px' }} />}
                    </div>
                </td >
            );
        });
        return tds;
    }

    const getInputColumn = (columnValue, index, columnName, errorsExists) => {
        return <input
            name={columnName + index + "input"}
            type="text"
            value={columnValue}
            style={{ width: errorsExists ? '70px' : '82px', border: 'white', borderRadius: '4px', height: '37px', textAlign: 'right' }}
            onChange={(e) => handleEdit(index, columnName, e.target.value)}
        />
    }

    const handleEdit = (index, field, value) => {
        dispatch(updateProperty(index, field, value));
    };

    const getStyle = (errorsExists) => {
        const errorStyle = errorsExists ? { backgroundColor: '#F38383' } : "";
        return { padding: '1px', ...errorStyle }
    }

    const createRow = (row) => {
        let newRow = {}
        const keys = Object.keys(row)
        for (let i = 0; i < CSV_HEADERS.length; i++) {
            const headersKey = CSV_HEADERS[i]
            if (keys.includes(headersKey)) {
                newRow[headersKey] = row[headersKey]?.toString()
            }
            else newRow[headersKey] = "";
            if (INT_FIELDS.includes(headersKey)) {
                newRow[headersKey] = newRow[headersKey]?.toString().replaceAll("'", "").replaceAll('"', "").replaceAll("-", "").replaceAll(",", "");
            }
        }
        return newRow
    }

    return { getRow, createRow };
}